<template>
    <div style="font-size: 14px;width: 100%">
        <v-layout row class="ma-0">
            <div style="color: rgba(166, 166, 166, 1);width: 60px;line-height: 21px">名称</div>
            <div style="width: 180px;height: 20px;margin-left: 17px">
                <v-text-field
                        maxLength="20"
                        class="jumpTextField"
                        v-model="editNameText"
                        background-color="rgba(56, 56, 56, 1)"
                        style="font-size: 14px;color: white;width: 180px"
                        dark
                        dense
                        height="20"
                        @blur="blurEditNameText()"
                >
                    <template v-slot:append>
                        <div style="font-size: 12px;color: rgba(128, 128, 128, 1);margin-top: 4px">{{editNameText.length}}/20</div>
                    </template>
                </v-text-field>
            </div>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "NameEditor",
        props:["currName","nameIndex"],
        data(){
            return{
                editNameText:this.currName,
                geoName:this.currName,
            }
        },
        methods:{
            blurEditNameText(){
                if(this.editNameText.length > 0 && this.editNameText.length < 21){
                    this.geoName = this.editNameText
                    let temp={
                        index:this.nameIndex,
                        text:this.editNameText
                    }
                    this.$emit("changeName",temp)
                }else{
                    this.$emit("errorValue",'长度不符合要求')
                }

            },
        }
    }
</script>

<style >
    .jumpTextField .v-input__slot{
        min-height: 20px !important;
        padding: 0 !important;
        margin: 0 !important;
    }
    .v-text-field{
        margin-top: 0 !important;
    }
</style>
